import { FC, useEffect } from "react";
import { applicationFields } from "../../../../config/viewDocumentsFields";
import "form-pattern/dist/main.css";
import { Form } from "../../../../components/common/Forms";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { fetchApplicationDetails } from "../../../../store/slices/Citizenship/viewDocumentSlice";
import Notifications from "../../../../components/common/Notifications";

const Applications: FC<any> = ({ empNuid }: { empNuid?: string | null }) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { applicationDetails, applicationDetailsError } = useAppSelector((state) => state.viewDocument);

  useEffect(() => {
    if (id) {
      if (empNuid) {
        dispatch(fetchApplicationDetails({ applicationId: id, empNuid }));
      } else {
        dispatch(fetchApplicationDetails(id));
      }
    }
  }, [id, empNuid]);



  if (applicationDetailsError) {
    return (
      <div className="flex items-center justify-center min-h-[60vh] px-4">
        <div className="w-full max-w-2xl">
          <div className="mx-auto">
            <Notifications messageInfo={applicationDetailsError} status={false} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="margin-top-4u space-y-5!">
      <h2 className="h3 ">Application information</h2>
      <Form fields={applicationFields} buttons={[]} isViewDetails={true} initialValues={applicationDetails || {}} />
    </div>
  );
};

export default Applications;
